module.exports = require("./shared/images");
